/**
 * Right Bid — Cliente HTTP Centralizado e Seguro
 * Suporte transparente a Cookies HttpOnly e Header Authorization: Bearer para ambientes restritos.
 */

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem("rb_token");
  const headers = new Headers(options.headers || {});

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const modifiedOptions: RequestInit = {
    ...options,
    headers,
    credentials: options.credentials || "include",
  };

  const response = await fetch(url, modifiedOptions);

  // Se receber 401 não autorizado em rota privada (que não seja tentativa de login)
  if (response.status === 401 && !url.includes("/api/auth/login")) {
    localStorage.removeItem("rb_token");
  }

  return response;
}
